export default __webpack_public_path__ + "static/test_1_2-13081d79d310ac48469dbbdce8cdca1d.png";